import React, { useEffect, useMemo, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator';
import API from '../../API';

export default function VisitorReport() {

    let allHeaders = {
        dayWiseByTimeZone: [
            { text: "Date", dataField: "day" },
            { text: "TimeZone", dataField: "timeZone" },
            { text: "Visits", dataField: "visits" },
        ],
        dayWiseDesktop: [
            { text: "Date", dataField: "day" },
            { text: "Device", dataField: "device" },
            { text: "Visits", dataField: "visits" },
        ],
        dayWiseMobile: [
            { text: "Date", dataField: "day" },
            { text: "Device", dataField: "device" },
            { text: "Visits", dataField: "visits" },
        ],
        dayWiseVisitors: [
            { text: "Date", dataField: "day" },
            { text: "Visits", dataField: "visits" },
        ]
    }

    const [headers, setHeaders] = useState(allHeaders.dayWiseVisitors)
    const [data, setData] = useState()
    const [loading, setLoading] = useState(true)
    const [fetchLoading, setFetchLoading] = useState(false)
    const [tableData, setTableData] = useState()
    const [dateRange, setDateRange] = useState({
        start: '',
        end: '',
        month: '',
        year: ''
    })
    const [selectedrange, setSelectedrange] = useState()

    const fetchData = async () => {
        // setLoading(true)
        setFetchLoading(true)
        try {
            const res = await API.get("/visitor-report")
            setData(res.data)
            setLoading(false)
            setFetchLoading(false)
        } catch (error) {
            setLoading(false)
            setFetchLoading(false)
            console.log(error);
        }
    }
    useEffect(() => {
        fetchData()
    }, [])

    useEffect(() => {
        if (data) {
            setTableData(data['dayWiseVisitors'])
        }
    }, [data])

    const finteredData = useMemo(() => {
        return tableData?.filter(item => {
            const date = new Date(item.day);
            if (selectedrange == 'monthyear') {
                return date.getFullYear() == dateRange.year && date.getMonth() == dateRange.month - 1
            } else if (selectedrange == 'daterange') {
                return date >= new Date(dateRange.start) && date <= new Date(dateRange.end)
            } else {
                return true
            }
        })
    }, [tableData, selectedrange, dateRange])

    return (
        <div className='py-3'>
            <div class="card">
                <div class="card-body">
                    <div className="text-center py-1 pb-4">
                        <h3>Visitor Report</h3>
                    </div>
                    {data && <>
                        <div className='d-flex justify-content-around pb-3'>
                            <div class="card" style={{ width: '200px' }}>
                                <div class="card-body text-center">
                                    <h5 class="card-title">{data?.todaysVisitCount}</h5>
                                    <h6 class="card-subtitle mb-2 text-muted">Today Total</h6>
                                </div>
                            </div>
                            <div class="card" style={{ width: '200px' }}>
                                <div class="card-body text-center">
                                    <h5 class="card-title">{data?.todaysVisitCountByMobile}</h5>
                                    <h6 class="card-subtitle mb-2 text-muted">Today By Mobile</h6>
                                </div>
                            </div>
                            <div class="card" style={{ width: '200px' }}>
                                <div class="card-body text-center">
                                    <h5 class="card-title">{data?.todaysVisitCountByDesktop}</h5>
                                    <h6 class="card-subtitle mb-2 text-muted">Today By Desktop</h6>
                                </div>
                            </div>
                        </div>
                        <div className='d-flex justify-content-around'>
                            <div class="card" style={{ width: '200px' }}>
                                <div class="card-body text-center">
                                    <h5 class="card-title">{data?.yesterdayVisits}</h5>
                                    <h6 class="card-subtitle mb-2 text-muted">Yesterday Total</h6>
                                </div>
                            </div>
                            <div class="card" style={{ width: '200px' }}>
                                <div class="card-body text-center">
                                    <h5 class="card-title">{data?.yesterdayVisitsByMobile}</h5>
                                    <h6 class="card-subtitle mb-2 text-muted">Yesterday By Mobile</h6>
                                </div>
                            </div>
                            <div class="card" style={{ width: '200px' }}>
                                <div class="card-body text-center">
                                    <h5 class="card-title">{data?.yesterdayVisitsByDesktop}</h5>
                                    <h6 class="card-subtitle mb-2 text-muted">Yesterday By Desktop</h6>
                                </div>
                            </div>
                        </div>
                    </>}
                    {data && <div className="pt-5">
                        <label htmlFor="">Please Select : &nbsp;</label>
                        <select class="form-control w-25 mb-3" aria-label="Default select example"
                            // style={{ width: '500px' }}
                            onClick={e => {
                                if (data) {
                                    setHeaders(allHeaders[e.target.value])
                                    setTableData(data[e.target.value])
                                }
                            }}>
                            {/* <option selected>Open this select menu</option> */}
                            <option value="dayWiseVisitors">Day wise visitors</option>
                            <option value="dayWiseByTimeZone">Day wise by timezone</option>
                            <option value="dayWiseDesktop">Day wise desktop</option>
                            <option value="dayWiseMobile">Day wise mobile</option>
                        </select>
                    </div>}

                    {data && <div className='d-flex w-25 justify-content-between'>
                        <div>
                            <div class="form-check">
                                <input type="radio" name="daterange"
                                    className='form-check-input' id='r1'
                                    checked={selectedrange == 'monthyear'}
                                    onClick={e => {
                                        setSelectedrange('monthyear')
                                        setDateRange({
                                            start: '',
                                            end: '',
                                            month: '',
                                            year: ''
                                        })
                                    }} />
                                <label for="r1" >
                                    Month and Year
                                </label>
                            </div>
                            <div class="form-check">
                                <input type="radio" name="daterange"
                                    className='form-check-input' id='r2'
                                    checked={selectedrange == 'daterange'}
                                    onClick={e => {
                                        setSelectedrange('daterange')
                                        setDateRange({
                                            start: '',
                                            end: '',
                                            month: '',
                                            year: ''
                                        })
                                    }} />
                                <label for="r2">
                                    Date Range
                                </label>
                            </div>
                        </div>
                        <div className=''>
                            <button type="button" className="btn btn-primary" onClick={() => {
                                setSelectedrange('')
                                setDateRange({
                                    start: '',
                                    end: '',
                                    month: '',
                                    year: ''
                                })
                            }}>Clear Filters</button>
                        </div>
                    </div>}

                    {selectedrange == 'daterange' && <div className='p-3'>
                        Start Date: <input type="date" className='form-control w-25'
                            onChange={e => {
                                setDateRange(pre => ({ ...pre, start: e.target.value }))
                            }} />
                        <br />
                        End Date: <input type="date" className='form-control w-25'
                            onChange={e => {
                                setDateRange(pre => ({ ...pre, end: e.target.value }))
                            }} />
                    </div>}
                    <div className="d-flex justify-content-end">
                        {!loading && <button type="button" className="btn btn-primary" onClick={() => fetchData()} disabled={fetchLoading} >
                            {fetchLoading ? "Refreshing..." : "Refresh"}
                        </button>}
                    </div>

                    {selectedrange == 'monthyear' && <div className='py-3'>
                        <div className=''>
                            <select className='form-control w-25 mb-2' name="month" onChange={e => { setDateRange(pre => ({ ...pre, month: e.target.value })) }}>
                                <option value="">Select Month</option>
                                <option value="1">January</option>
                                <option value="2">February</option>
                                <option value="3">March</option>
                                <option value="4">April</option>
                                <option value="5">May</option>
                                <option value="6">June</option>
                                <option value="7">July</option>
                                <option value="8">August</option>
                                <option value="9">September</option>
                                <option value="10">October</option>
                                <option value="11">November</option>
                                <option value="12">December</option>
                            </select>
                            <select className='form-control w-25' name="year" onChange={e => { setDateRange(pre => ({ ...pre, year: e.target.value })) }}>
                                <option value="">Select Year</option>
                                <option value="2022">2022</option>
                                <option value="2023">2023</option>
                                <option value="2024">2024</option>
                                <option value="2025">2025</option>
                                <option value="2026">2026</option>
                            </select>
                        </div>
                    </div>}



                    <div style={{ marginTop: "20px", marginBottom: "20px", overflowX: "scroll" }}>
                        {finteredData && <BootstrapTable
                            keyField="srno"
                            data={finteredData}
                            columns={headers}
                            headerClasses="allTable_header text-center"
                            pagination={paginationFactory()}
                        />}
                        {loading && <div className="text-center">
                            <h4>Please wait ... </h4>
                        </div>}
                        {/* <ul class="pagination">
                            <li class="page-item"> <button type="button" class="btn btn-primary mr-1">Previous</button> </li>
                            <li class="page-item"> <button type="button" class="btn btn-primary mr-1">1</button> </li>
                            <li class="page-item"> <button type="button" class="btn btn-primary mr-1">2</button> </li>
                            <li class="page-item"> <button type="button" class="btn btn-primary mr-1">3</button> </li>
                            <li class="page-item"> <button type="button" class="btn btn-primary mr-1">Next</button> </li>
                        </ul> */}
                    </div>
                </div>
            </div>
        </div>
    )
}
